module.exports = __webpack_public_path__ + "static/media/ratilanna.449551e5.png";